const {
  GatsbyWrapperPageElement,
} = require("./src/components/GatsbyWrapperPageElement");

exports.wrapPageElement = GatsbyWrapperPageElement;
